import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SpinnerComponent } from "src/app/components/layout/spinner/spinner.component";
import { MenuService } from 'src/app/services/menu/menu.service';

@Component({
  selector: 'app-parent-menu-select',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    SpinnerComponent
  ],
  templateUrl: './parent-menu-select.component.html',
  styleUrl: './parent-menu-select.component.css'
})
export class ParentMenuSelectComponent {
  @Input() allMenu: any[] | null = null;
  @Input() selectedMenuId: number | null = null;
  @Output() selected = new EventEmitter<number>();

  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  searchControl = new FormControl('');
  filteredPages: any[] = [];

  load = false;
  error = false;

  constructor(private MenuService: MenuService){}

  ngOnInit() {
      this.load = true;

      this.MenuService.getMenu().subscribe(
        (res: any) => {
          this.load = false;
          this.allMenu = res.data;   // ❗ აქ ხდება ჩატვირთვა API-დან
          const safeQuery = ''; // no initial filter
          this.filteredPages = !safeQuery
          ? this.flattenMenu(this.allMenu)
          : this.flattenMenu(this.allMenu).filter((p) =>
              (p?.title || '').toLowerCase().includes(safeQuery)
          );// flattened list


          if (this.selectedMenuId !== null) {
            this.setSelectedPage(this.selectedMenuId);
          }

        },
        (error) => {
          this.load = false;
          this.error = true;
        }
      );

      this.listenToSearch();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.allMenu && !Array.isArray(this.allMenu)) {
      this.allMenu = Object.values(this.allMenu);
    }
    if (changes['allMenu'] && Array.isArray(this.allMenu)) {
      this.filteredPages = [...this.allMenu];
      if (this.selectedMenuId !== null) {
        this.setSelectedPage(this.selectedMenuId);
      }
    }
  }

  ngAfterViewInit() {
    if (this.filteredPages.length && this.autocompleteTrigger) {
      this.autocompleteTrigger.openPanel();
    }
  }

  private flattenMenu(list: any[], depth = 0): any[] {
  const flat: any[] = [];
  for (const item of list) {
    flat.push({ ...item, depth }); // შეინახე depth indentation
    if (item.children && item.children.length) {
      flat.push(...this.flattenMenu(item.children, depth + 1));
    }
  }
  return flat;
}

  private findPageRecursive(list: any[], id: number): any | null {
    if (!Array.isArray(list)) return null;
    for (const p of list) {
      if (p == null) continue;
      // match common id fields (id, page) and tolerate string/number
      if (p.id == id || p.page == id) return p;
      // some APIs use nested children arrays under different keys
      const children = p.children || p.child || p.items || p.pages;
      if (children && Array.isArray(children)) {
        const found = this.findPageRecursive(children, id);
        if (found) return found;
      }
    }
    return null;
  }

  setSelectedPage(pageId: number) {
    if (pageId == null) return;
    const idNum = typeof pageId === 'string' ? Number(pageId) : pageId;
    const selectedPage = this.findPageRecursive(this.allMenu || [], idNum);
    // debug logs (can be removed later)
    console.log('setSelectedPage: looking for', idNum);
    console.log('setSelectedPage: selectedPage ->', selectedPage);

    if (selectedPage) {
      this.searchControl.setValue(selectedPage);
    }
  }

  filterPages(query: any = '') {
    if (!this.allMenu) return;

    const safeQuery = String(query || '').toLowerCase();

    this.filteredPages = !safeQuery
      ? [...this.allMenu]
      : this.allMenu.filter((p) =>
          (p?.title || '').toLowerCase().includes(safeQuery)
        );
  }

  listenToSearch() {
    this.searchControl.valueChanges.subscribe((value) => {
      if (typeof value === 'string' || value === '') {
        this.filterPages(value);
        if (this.filteredPages.length && this.autocompleteTrigger) {
          this.autocompleteTrigger.openPanel();
        }
      } else {
        this.filterPages(this.searchControl.value || '');
      }
    });
  }

  onSelect(value: any) {
    this.selected.emit(value?.id || 0);
  }

  displayFn = (page: any) => {
    return page?.title || '';
  };

  onInputClick(): void {
    if (this.autocompleteTrigger) {
      this.autocompleteTrigger.openPanel();
    }
  }
}
